/* ALQUIMIA CLUB — captura de UTM/fbclid y envío como cart attributes
 * ------------------------------------------------------------------
 * Vanilla JS, sin dependencias externas. Cargado desde
 * snippets/custom-code-body.liquid en todas las páginas.
 *
 * 1) Al cargar la página, lee utm_source/utm_medium/utm_campaign/utm_content/
 *    utm_term/fbclid de la URL actual. Si hay al menos uno presente, los
 *    guarda en localStorage con timestamp (expiran a los 30 días). Si la URL
 *    actual no trae ninguno, NO se sobreescriben los valores guardados
 *    previamente (mientras sigan vigentes).
 * 2) Cuando se detecta que se añadió un producto al carrito, reenvía los
 *    valores guardados como cart attributes vía /cart/update.js.
 *
 * Cómo se detecta "producto añadido al carrito":
 *  assets/cart.js (revisado antes de escribir este archivo) emite un evento
 *  custom `cart:updated` (document.dispatchEvent) desde
 *  MCartTemplate.updateQuantity(), pensado para cambios de cantidad dentro
 *  del carrito/drawer ya abiertos — no hay garantía de que TODOS los flujos
 *  de "agregar al carrito" (quick add, botón de producto, etc.) pasen por
 *  ahí. Por eso la señal principal aquí es un interceptor de fetch() sobre
 *  las llamadas a /cart/add(.js), que es el endpoint que Shopify usa siempre
 *  para agregar al carrito sin importar qué componente del tema lo dispare.
 *  Además, también se escucha `cart:updated` como señal secundaria — no hace
 *  daño reenviar los mismos atributos más de una vez.
 */
(function () {
  "use strict";

  var STORAGE_KEY = "alquimia_club_utm";
  var MAX_AGE_MS = 30 * 24 * 60 * 60 * 1000; // 30 días
  var UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term", "fbclid"];

  function readStored() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (!parsed || !parsed.ts || !parsed.values) return null;
      if (Date.now() - parsed.ts > MAX_AGE_MS) return null;
      return parsed;
    } catch (e) {
      return null;
    }
  }

  function writeStored(values) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify({ ts: Date.now(), values: values }));
    } catch (e) {
      /* localStorage no disponible (modo privado, cuota llena, etc.) — no hacemos nada */
    }
  }

  function captureFromUrl() {
    var params;
    try {
      params = new URLSearchParams(window.location.search);
    } catch (e) {
      return;
    }

    var incoming = {};
    var hasAny = false;
    UTM_KEYS.forEach(function (key) {
      var value = params.get(key);
      if (value) {
        incoming[key] = value;
        hasAny = true;
      }
    });

    if (!hasAny) {
      // No hay UTMs en la URL actual: no tocamos lo que ya hubiera guardado.
      return;
    }

    // Hay UTMs nuevos en la URL: reemplazan el set guardado (nueva sesión de
    // atribución), no se mezclan con los viejos.
    writeStored(incoming);
  }

  function buildAttributesPayload() {
    var stored = readStored();
    if (!stored || !stored.values) return null;

    var attributes = {};
    var hasAny = false;
    UTM_KEYS.forEach(function (key) {
      if (stored.values[key]) {
        attributes[key] = stored.values[key];
        hasAny = true;
      }
    });

    return hasAny ? attributes : null;
  }

  function sendAttributesToCart() {
    var attributes = buildAttributesPayload();
    if (!attributes) return;

    fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ attributes: attributes }),
    }).catch(function () {
      /* fallo silencioso: no debe bloquear la experiencia de compra */
    });
  }

  function isCartAddRequest(input) {
    var url = "";
    if (typeof input === "string") {
      url = input;
    } else if (input && typeof input.url === "string") {
      url = input.url;
    }
    return url.indexOf("/cart/add") !== -1;
  }

  function installFetchInterceptor() {
    if (!window.fetch || window.__alquimiaClubFetchPatched) return;
    window.__alquimiaClubFetchPatched = true;

    var originalFetch = window.fetch;
    window.fetch = function (input, init) {
      var isAdd = isCartAddRequest(input);
      var result = originalFetch.apply(this, arguments);

      if (isAdd) {
        result
          .then(function (response) {
            if (response && response.ok) {
              sendAttributesToCart();
            }
            return response;
          })
          .catch(function () {
            /* si /cart/add falló, no reenviamos atributos */
          });
      }

      return result;
    };
  }

  function installCartUpdatedListener() {
    // Señal secundaria: ver comentario al inicio del archivo.
    document.addEventListener("cart:updated", function () {
      sendAttributesToCart();
    });
  }

  captureFromUrl();
  installFetchInterceptor();
  installCartUpdatedListener();
})();
